import { motion } from 'framer-motion';
import { FaHeart, FaUsers, FaChalkboardTeacher } from 'react-icons/fa';
import { useContent } from '../contexts/ContentContext';

const Services = () => {
  const { content } = useContent();
  const servicesContent = content.services || {};

  const services = [
    {
      icon: <FaHeart className="text-5xl text-[#D4B4A8]" />,
      title: servicesContent.service1Title || 'Psicoterapia Individual',
      description: servicesContent.service1Description || 'Atendimento personalizado para adultos, focado no autoconhecimento e desenvolvimento pessoal.',
    },
    {
      icon: <FaUsers className="text-5xl text-[#D4B4A8]" />,
      title: servicesContent.service2Title || 'Terapia Online',
      description: servicesContent.service2Description || 'Sessões realizadas por videoconferência, oferecendo flexibilidade e comodidade.',
    },
    {
      icon: <FaChalkboardTeacher className="text-5xl text-[#D4B4A8]" />,
      title: servicesContent.service3Title || 'Palestras',
      description: servicesContent.service3Description || 'Apresentações e workshops sobre temas relacionados à saúde mental, desenvolvimento pessoal e bem-estar emocional para empresas e grupos.',
    },
  ];

  return (
    <section id="servicos" className="py-24 bg-[#F8F3F0] relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-[#D4B4A8]/10 to-transparent"></div>
        <div className="absolute bottom-0 right-0 w-full h-full bg-gradient-to-tl from-[#4A3B36]/5 to-transparent"></div>
      </div>

      <div className="container mx-auto px-4 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl font-bold text-[#4A3B36] mb-6 relative inline-block">
            {servicesContent.title || 'Serviços'}
            <motion.div
              className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-[#D4B4A8] to-[#4A3B36]"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            />
          </h2>
          <p className="text-[#6B5C57] text-xl max-w-2xl mx-auto mt-6">
            {servicesContent.description || 'Ofereço atendimento psicológico humanizado e acolhedor, adaptado às necessidades de cada pessoa.'}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              whileHover={{ y: -10 }}
              className="group relative"
            >
              {/* Card Background with Gradient Border */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#D4B4A8] to-[#4A3B36] rounded-2xl transform rotate-1 group-hover:rotate-3 transition-transform duration-300"></div>
              
              {/* Main Card Content */}
              <div className="relative bg-white rounded-2xl p-8 transform -rotate-1 group-hover:rotate-0 transition-transform duration-300 h-full flex flex-col">
                {/* Icon Container with Animation */}
                <motion.div
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  className="w-20 h-20 rounded-xl bg-gradient-to-br from-[#F8F3F0] to-white flex items-center justify-center mx-auto mb-6 shadow-lg transform -translate-y-12 group-hover:-translate-y-14 transition-transform duration-300"
                >
                  {service.icon}
                </motion.div>

                <h3 className="text-2xl font-bold text-[#4A3B36] mb-4 group-hover:text-[#D4B4A8] transition-colors duration-300">
                  {service.title}
                </h3>

                <p className="text-[#6B5C57] flex-grow">
                  {service.description}
                </p>

                {/* Hover Effect Overlay */}
                <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                  <div className="absolute inset-0 bg-gradient-to-t from-white/50 to-transparent"></div>
                </div>

                {/* Learn More Link */}
                <motion.div
                  initial={{ opacity: 0 }}
                  whileHover={{ opacity: 1 }}
                  className="mt-6 text-[#4A3B36] font-medium flex items-center justify-center group-hover:text-[#D4B4A8] transition-colors duration-300"
                >
                  <span>Saiba mais</span>
                  <svg
                    className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </motion.div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
